export class RmColumnRequest{
    columnsId?: number;
    constructor(columnsId:number){
        this.columnsId = columnsId;
    }
}